import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const ellipseCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default ellipseCommands;
